var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: "Incubator",
                  items: _vm.incubatorRackListGroupKeys,
                  "item-value": "id",
                  "item-text": "code",
                  dense: "",
                  "hide-details": ""
                },
                model: {
                  value: _vm.incubatorRackListGroupKey,
                  callback: function($$v) {
                    _vm.incubatorRackListGroupKey = $$v
                  },
                  expression: "incubatorRackListGroupKey"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-text-field", {
                attrs: { label: "Date", type: "date", "hide-details": "auto" },
                model: {
                  value: _vm.date,
                  callback: function($$v) {
                    _vm.date = $$v
                  },
                  expression: "date"
                }
              })
            ],
            1
          ),
          _vm._l(_vm.rackList, function(item, index) {
            return _c(
              "v-col",
              { key: index, attrs: { cols: "6" } },
              [
                _c("v-text-field", {
                  attrs: {
                    label: item.code,
                    dense: "",
                    "hide-details": "auto",
                    type: "number",
                    "hide-spin-buttons": "",
                    clearable: "",
                    "error-messages":
                      _vm.rackEggPostErrors[
                        `data.${item.id}.incubator_rack_id`
                      ] || _vm.rackEggPostErrors[`data.${item.id}.quantity`]
                  },
                  model: {
                    value: _vm.quantities[item.id],
                    callback: function($$v) {
                      _vm.$set(_vm.quantities, item.id, $$v)
                    },
                    expression: "quantities[item.id]"
                  }
                })
              ],
              1
            )
          }),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "green",
                    dark: "",
                    block: "",
                    loading: _vm.rackEggPosting
                  },
                  on: { click: _vm.store }
                },
                [_vm._v("store")]
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }